import React from "react";
import PageTitle from "../../components/pageTitle";

const Price = () => {
  return (
    <div>
      {" "}
      <PageTitle title={"هزینه"} />
    </div>
  );
};

export default Price;
